import HttpService from "@/utils/httpData"

export const getAllTypeFilter = params => {
    let apiEndpoint = `library/filter-library`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getAllClassFilter = params => {
    let apiEndpoint = `Classes/GetListClasses`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getUserInfoByUserId = params => {
    let apiEndpoint = `Home/GetUserInfoByUserId?userId=${params}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}